import { Kpi } from "../../components/ui/Kpi";
import type { RebalancePreviewResponse } from "../../lib/api";
import { formatPercent, formatUsdcRaw } from "../../lib/format";

export function RebalanceKpis({ data }: { data: RebalancePreviewResponse }) {
	const d = data.decision;
	const c = data.costEstimate;
	return (
		<div className="grid grid-cols-2 gap-3 md:grid-cols-3">
			<Kpi
				label="Expected APY"
				value={formatPercent(d.expectedApyCurrent)}
				tone="neutral"
				hint={`→ ${formatPercent(d.expectedApyTarget)} (Δ ${formatPercent(d.expectedApyDelta)})`}
			/>
			<Kpi
				label="Net benefit"
				value={formatUsdcRaw(d.expectedNetBenefitRaw)}
				tone="positive"
				hint={`gross ${formatUsdcRaw(d.expectedBenefitRaw)} − cost ${formatUsdcRaw(d.estimatedTradingCostRaw)}`}
			/>
			<Kpi
				label="Total cost (estimate)"
				value={formatUsdcRaw(c.expectedTotalCostRaw)}
				tone="muted"
				hint={`gas ${formatUsdcRaw(c.expectedGasCostRaw)} · frictions ${formatUsdcRaw(c.expectedExecutionCostRaw)}`}
			/>
		</div>
	);
}
